import { AppBar, Toolbar } from "@mui/material";
function DashBar() {
  return (
    <AppBar
      className="app-bar"
      sx={{ zIndex: (theme) => theme.zIndex.drawer + 1
      }}
    >
      <Toolbar >
        <div className="text">
          <span>PureEng</span> Dashboard
        </div>
      </Toolbar>
    </AppBar>
  );
}

export default DashBar;
